import React, { useMemo } from 'react';
import { FormikValues, useFormikContext } from 'formik';
import _ from 'lodash';
import { BlockWrapper } from '../../types/general';
import { resolveCondition } from '../../app/validation';

export const ConditionWrapper: BlockWrapper = ({ children, schema }) => {
	const { values } = useFormikContext<FormikValues>();

	const isVisible = useMemo(() => {
		if (schema.hidden) return false;
		const { conditions = [] } = schema || {};
		if (conditions && conditions.length) {
			return conditions.reduce((acc, block) => {
				// OR (if one is true return true)
				if (acc) return acc;
				const ret = block.reduce((acc2, condition) => {
					// AND (if one is false, invalidate and return false)
					if (!acc2) return acc2;
					const res = resolveCondition(values, condition);
					if (res !== undefined) return res;
					return acc2;
				}, true);
				if (ret) return true;
				else return acc;
			}, false);
		}
		return true;
	}, [schema, values]);
	if (!isVisible) return null;

	return <React.Fragment>{children}</React.Fragment>;
};
